module.exports = __webpack_public_path__ + "static/headers_not_freezed-530ac2294c82900dc0960f113c433acc.jpg";